import React from "react";

import { Section, Stack } from "@origin-digital/ods-core";

import { Transcript, Video } from "src/components/Video";

import { Benefits, Benefit } from "../../components/Benefits";

import content from "./content.json";

export const AppSection: React.FC = () => (
  <Section>
    <Benefits heading={content.heading}>
      <Benefit
        heading={content.benefit.heading}
        text={content.benefit.text}
        reverse
        apps
        top
      >
        <Stack space="medium">
          <Video content={content.video} />
          <Transcript content={content.video} />
        </Stack>
      </Benefit>
    </Benefits>
  </Section>
);
